{
  "version": 1,
  "asset_id": "e4998e6b-7638-40f8-ac90-c3608c159e12",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/e4998e6b-7638-40f8-ac90-c3608c159e12/buyukcekmece-isyeri-2.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/e4998e6b-7638-40f8-ac90-c3608c159e12/buyukcekmece-isyeri-2.jpg",
  "original_filename": "buyukcekmece-isyeri-2.jpg",
  "size": 679504,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T07:24:10Z"
}
